<template>
  <div class="animated fadeIn">
    <b-card v-if="list" :footer="(list.anoMesMovimento ? ('Referência: ' + list.anoMesMovimento.toString()) : '')" no-body>
      <b-tabs id="tabsIap" bg-variant="dark" tabs fill>
        <b-tab title="Todos" id="tab1" active>
          <div class="card-body">
            <h5>{{every.length}} Produtos</h5>
            <hr>
            <ul style="gap: .5rem" class="list-unstyled d-flex flex-wrap">
              <li class="listItem" v-for="(item, index) in every" :key="index">
                <i :class="{
                  'fas fa-check text-success': item[1] === 'SIM',
                  'fas fa-times text-danger': item[1] === 'NÃO'
                }"></i>
                {{ getNameFromEnum(item[0]) }}
              </li>
            </ul>
          </div>
        </b-tab>

        <b-tab title="Ativos" id="tab2" >
          <div class="card-body">
            <h5>{{active.length}} Ativos</h5>
            <hr>
            <ul style="gap: .5rem" class="list-unstyled d-flex flex-wrap">
              <li class="listItem" v-for="(item, index) in active" :key="index">
                <i :class="{
                  'fas fa-check text-success': item[1] === 'SIM',
                  'fas fa-times text-danger': item[1] === 'NÃO'
                }"></i>
                {{ getNameFromEnum(item[0]) }}
              </li>
            </ul>
          </div>
        </b-tab>

        <b-tab title="Inativos" id="tab3">
          <div class="card-body">
            <span class="d-inline-block"><h5>{{inactive.length}} Inativos</h5></span>
            <hr>
            <ul style="gap: .5rem" class="list-unstyled d-flex flex-wrap">
              <li class="listItem" v-for="(item, index) in inactive" :key="index">
                <i :class="{
                  'fas fa-check text-success': item[1] === 'SIM',
                  'fas fa-times text-danger': item[1] === 'NÃO'
                }"></i>
                {{ getNameFromEnum(item[0]) }}
              </li>
            </ul>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import IAPRepository from '@/shared/http/repositories/business/iap.js'
import PRODUCTS from '@/enums/iapProducts.js'
import { BNav, BNavItem, BTabs, BTab } from 'bootstrap-vue'

export default {
  name: 'BankCheck',
  mixins: [ActionsForm],
  components: {
    BNav,
    BNavItem,
    BTabs,
    BTab
  },
  data () {
    return {
      document: null,
      list: {}
    }
  },
  mounted () {
    if (this.document) {
      this.onLoadIap(this.document)
    }
  },
  computed: {
    every () {
      let asArray = Object.entries(this.list)
      return asArray.filter(([key, value]) => value === 'NÃO' || value === 'SIM')
    },
    active () {
      let asArray = Object.entries(this.list)
      return asArray.filter(([key, value]) => value === 'SIM')
    },
    inactive () {
      let asArray = Object.entries(this.list)
      return asArray.filter(([key, value]) => value === 'NÃO')
    }
  },
  methods: {
    onLoadIap (document) {
      loading.push()
      this.document = document
      IAPRepository.Search(document)
        .then((response) => {
          this.list = response.data.content[0]
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    getNameFromEnum (value) {
      if (value === 'produtoChequeEspecialContaGarantida') {
        if (this.list.document.length === 11) {
          return PRODUCTS['produtoChequeEspecial']
        } else {
          return PRODUCTS['produtoContaGarantida']
        }
      }
      return PRODUCTS[value]
    }
  }
}
</script>
<style lang="scss">
#tabsIap {
  .nav-tabs {
    background: #04a791 !important;
    border-radius: 4px 4px 0 0;
  }

  .nav-tabs .nav-link,
  .nav-tabs .navbar .dropdown-toggle,
  .navbar .nav-tabs .dropdown-toggle {
    color: #FFF;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .navbar .active.dropdown-toggle,
  .navbar .nav-tabs .active.dropdown-toggle {
    color: #04a791;
  }
}
</style>
<style lang="scss" scoped>
.listItem {
  width: calc(25% - .5rem);

  @media screen and (max-width: 800px) {
    width: calc(33% - .5rem);
  }

  @media screen and (max-width: 600px) {
    width: calc(50% - .5rem);
  }

  @media screen and (max-width: 360px) {
    width: calc(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/iap.vue